import React, { useState, useEffect } from 'react';
import { Button, Form, Input } from 'antd';
import calendarPng from 'assets/images/calendar.png';
import ModalEndSubmit from '../../../Organisms/Modals/ModalEndSubmit/ModalEndSubmit';
import { useForm } from 'antd/es/form/Form';

interface Props {
  response?: any;
}

const CardSomeoneElse = ({ response }: Props) => {

  const [form] = useForm();
  const [isModalConfirm, setIsModalConfirm] = useState(false);

  useEffect(() => {
    if (response) {
      form.setFieldsValue({
        name: response.metadata?.name,
        lastName: response.metadata?.lastName,
        email: response.metadata?.email,
        phone: response.metadata?.phone,
      });
    }
  }, [response, form]);

  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div className="CardSomeoneElse">
      <Form
        form={form}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <div className="row">
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: 'Please input your username!'
              }
            ]}
          >
            <Input placeholder="First name" />
          </Form.Item>

          <Form.Item
            name="lastName"
            rules={[
              {
                required: true,
                message: 'Please input your password!'
              }
            ]}
          >
            <Input placeholder="Last name" />
          </Form.Item>
        </div>
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: 'Please input your password!'
            }
          ]}
        >
          <Input placeholder="Email address" />
        </Form.Item>
        <Form.Item
          name="phone"
          rules={[
            {
              required: true,
              message: 'Please input your password!'
            }
          ]}
        >
          <Input placeholder="Phone number" />
        </Form.Item>
      </Form>
      <ModalEndSubmit
        visible={isModalConfirm}
        setVisible={setIsModalConfirm}
        buttonAction={{ label: 'Submit and complete task', disabled: true }}
        modal={{
          title: 'Ready to submit?',
          description: (
            <h4 className="h4 h4-w4">
              After submitting, you’ll have to contact us if you want to make
              changes to the property access details
            </h4>
          )
        }}
        className="modal-end-submit--white"
        icon={calendarPng}
        buttonSubmit={
          <Button className="button button-modal-ok">
            Yes, this is correct
          </Button>
        }
        buttonCancel={
          <Button className="button button-modal-cancel">
            I want to make changes
          </Button>
        }
        isCheckBox={false}
        textCheckbox=""
      />
    </div>
  );
};
export default CardSomeoneElse;
